import React from 'react';
import './Card.css';

/**
 * Card component for displaying content sections
 * 
 * @param {string} variant - Card style variant: 'default', 'elevated', 'outlined'
 * @param {string} className - Additional CSS classes
 * @param {React.ReactNode} children - Card content
 * @param {object} props - Additional props to pass to the card element
 */
const Card = ({
  variant = 'default',
  className = '',
  children,
  ...props
}) => {
  const cardClasses = [
    'card',
    `card--${variant}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClasses} {...props}>
      {children}
    </div>
  );
};

export default Card;
